import { IconButton } from "@material-ui/core";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import { FC, useEffect, useState } from "react";
import { useNotify, useRefresh } from "react-admin";

import ConfirmationPopover from "../../../../components/ConfirmationPopover";
import TooltipPopover from "../../../../components/TooltipPopover";
import colors from "../../../../theme/colors";
import { DocReference } from "../../../../types/firebase.types";
import { applyUpdateTimestamp } from "../../../../utils/timestamp";

import { RequestStatus } from "../types";
import { fetchRequestChangedTimes } from "../utils/requestChangedTimes";
import { requestFetchedData } from "../utils/requestData";

const RejectRequest: FC<any> = (props) => {
  const refresh = useRefresh();
  const notify = useNotify();

  const [isThereChangedDate, setIsThereChangedDate] = useState(false);

  const handleReject = async (ref: DocReference) => {
    const sn = await requestFetchedData(ref);
    if (sn?.status === RequestStatus.pending) {
      try {
        await ref.update(
          applyUpdateTimestamp({
            status: RequestStatus.rejected,
          })
        );
        refresh();
        notify("Request rejected", "success");
      } catch (ex: any) {
        console.log(ex.message);
        notify("Error on rejecting request", "error");
      }
    } else {
      notify("Request has been expired", "error");
    }
  };

  useEffect(() => {
    (async function () {
      const fetchedData: any = await fetchRequestChangedTimes(props.record);
      setIsThereChangedDate(!!!fetchedData);
    })();
  }, []);

  return isThereChangedDate ? (
    <ConfirmationPopover
      onConfirm={() => handleReject(props.record.ref)}
      message="Are you sure you want to reject request?"
      confirmationText="Confirm"
      confirmationColor="secondary"
      Icon={
        <TooltipPopover message="Reject">
          <IconButton>
            <HighlightOffIcon style={{ color: colors.info.main }} />
          </IconButton>
        </TooltipPopover>
      }
    />
  ) : null;
};

export default RejectRequest;
